module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-13-1d93fd80b9d5a3255001de413ae311e2.jpg";